import { apiUrl } from '../config/api'

export async function listAlertsByDocId(docId) {
  let params = {
    documentId: docId
  }

  let url = apiUrl('ListAlertsByDocumentId')

  return sendReq(params, url)
}

export async function listSuggestionsByClientId(clientId) {
  let params = {
    clientId: clientId
  }

  let url = apiUrl('ListSuggestionsByClient')

  return sendReq(params, url)
}

export async function insertAlert(params) {
  let url = apiUrl('InsertAlert')

  return sendReq(params, url)
}

async function sendReq(params, url) {
  let res = await fetch(url, { method: 'POST', body: JSON.stringify(params) })
  return res.json()
}
